export const composeInvite = (t, firstName, customText, link) => {
  const invite = (customText || '').trim() || t('v2.moments.inviteDefault', { name: firstName });
  return `${invite}\n\n${t('v2.moments.inviteSystem', { name: firstName })}\n\n${link}`;
};
